import { BaseApiService } from '../../../api/base';
import type {
  RequestEmailValidationResponse,
  ValidateEmailByLinkResponse,
  ValidateEmailResponse,
} from '../types/email';

class EmailApiService extends BaseApiService {
  async requestEmailValidation(): Promise<RequestEmailValidationResponse> {
    return this.post<RequestEmailValidationResponse>(
      'email/request-validation',
      undefined
    );
  }

  async validateEmail(code: string): Promise<ValidateEmailResponse> {
    return this.post<ValidateEmailResponse>('email/validate', { code });
  }

  // Validates the email from the link in the validation email. Proxied through
  // to identity and served anonymously: the click arrives from a mail client
  // with no session, so the single-use token is the only credential.
  async validateEmailByLink(
    token: string
  ): Promise<ValidateEmailByLinkResponse> {
    return this.post<ValidateEmailByLinkResponse>(
      'email/validate-link',
      { token },
      { headers: { 'X-Domain': 'volt' } }
    );
  }
}

export const emailApiService = new EmailApiService();
